import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useLikeMutation as UseLikeMutation,
  type useLikeMutation$data
} from '@/__generated__/useLikeMutation.graphql'

type CommitAsyncFn = (toUserId: string) => Promise<useLikeMutation$data>

export const useLikeMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseLikeMutation>(graphql`
    mutation useLikeMutation($input: CreateLikeInput!) {
      createLike(input: $input) {
        clientMutationId
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (toUserId: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              like: {
                toUserId
              }
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
